import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
// components
import { Row } from "react-bootstrap";
import { BsFillPlusCircleFill } from "react-icons/bs";

import SearchBar from "../../../components/SearchBar";
import Dialog from "../create/dialog";
import ProtectedAccess  from '../../../components/ProtectedAccess'
import TextLoader from '../../../components/TextLoader/TextLoader';
import AuthorDetails from "../detailled";
//style
import "../style.css";
//page
import AuthorItem from "../item";
import { getRandomAuthors, searchAuthorByText } from '../../../api/authors';
import CustomPagination from '../../../components/CustomPagination';

import { saveStorageAuthors, getStorageAuthors } from '../../../utils/common';

const AUTHORS_PER_PAGE = 12; // TODO: add to admin settings 

const AuthorGallery = (props) => {

  const { lang = {} } = props;
  
  const [loading, setLoading] = useState(true);
  const [authors, setAuthors] = useState([]);
  const [step, setStep] = useState(1);
  const [pages, setPages] = useState(1);
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(null);
  const [query, setQuery]= useState(props.query || "");
  const [viewer, setViewer]= useState(false);
  const params = useParams()
  const history = useNavigate()
  const { id } = params;

  const handleClose = async () => {
    setCurrent(null);
    setShow(false);
  };

  const handleShow = (user) =>{
    setCurrent(user)
    setShow(true)
  };

  const fetchAuthors = async () => {
    setViewer(false);
    if (query){
      setLoading(true);
      setStep(1)
      history("/editorial/authors")
      const {data:{docs, pages}} = await searchAuthorByText(query)
        .catch(function (error) {
          setLoading(false);
          return {data:[]};
        })
      setAuthors(docs);
      setPages(pages);
      setLoading(false);
      return null;
    }else{
      // Busque en el storage
      let data = getStorageAuthors(step)
      // Busque en la API
      if(!data){
        const {data:{docs, pages}} = await getRandomAuthors(AUTHORS_PER_PAGE, step)
        .catch(function (error) {
          setLoading(false);
          return {data:[]};
        })
        // Aleatorice
        let books = docs.sort((a, b) => Math.random() < 0.6 ? 1 : -1)
        // Guarde en el storage
        saveStorageAuthors({books, offset:step, pages})
        // Show authors
        setAuthors(books);
        setLoading(false);
        setPages(pages);
        return null;
      }
      const {books, pages}=data;
      // Show authors
      setAuthors(books);
      setLoading(false);
      setPages(pages);
      return null;
    }
  }

  useEffect(() => {
    if(id){
      setViewer(true);
    }else{
      fetchAuthors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, query])

  useEffect(() => {
    if(query !== ""){fetchAuthors();}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])
  
  const nextFetchAuthors = async (step) => {
    setLoading(true);
    if (query){

    }else{
      // Busque en el storage
      let data = getStorageAuthors(step)
      // Busque en la API
      if(!data){
        const {data:{docs, pages}} = await getRandomAuthors(AUTHORS_PER_PAGE, step)
        .catch(function (error) {
          setLoading(false);
          return {data:[]};
        })
        // Aleatorice
        let books = docs.sort((a, b) => Math.random() < 0.6 ? 1 : -1)
        // Guarde en el storage
        saveStorageAuthors({books, offset:step, pages})
        // Show authors
        setAuthors(books);
        setLoading(false);
        setPages(pages);
        return null;
      }
      const {books, pages}=data;
      // Show authors
      setAuthors(books);
      setLoading(false);
      setPages(pages);
      return null;
    }
  }

  const paginateAuthors = () => {
    let authorsToDisplay = [];
    authorsToDisplay = authors.map(item=>{
      //authorsToDisplay.push(
      return( <AuthorItem 
          key={item._id} 
          id={item._id} 
          author={item} 
          AUTHORS_PER_PAGE={AUTHORS_PER_PAGE} 
          handleShow={()=>handleShow(item)}
          lang={lang} />
      )
    })
    return authorsToDisplay;
  }

  const updateStorage = (resp) =>{
    const {data: book} = resp;
    // updateStorage
    let {books, pages} = getStorageAuthors(step)
    let updated=[];

    if(resp.delete){
      updated = books.filter((item) => book._id !== item._id);
    }/*else if(resp.create){
      books.push(book);
      updated = books;
      console.log("updated >>>> ", updated)
    }*/else{
      updated = books.map(item=>{
        if(book._id === item._id) return book;
        return item;
      });
    }

    saveStorageAuthors({books:updated, offset:step, pages})
    // reloadStorageAuthors
    setAuthors(updated);
  }

  const displayAuthors = () => {
    return (
      <>
          <div className="gallery" style={{ display:'flex', flexWrap:'wrap', justifyContent:'center' }}>  
            <Row style={{ width:'100%', display:'flex', justifyContent:'center' }}>
              <Dialog
                show={show} 
                handleClose={handleClose}
                lang={lang}
                current={current}
                onFinish={(resp)=> updateStorage(resp) }
              />
            <ProtectedAccess 
                element={
                  <div>
                    <button 
                      className="btn btn-primary"
                      style={{ margin:'10px 0px', width:'100%' }}
                      onClick={()=>handleShow(null)} >
                        <BsFillPlusCircleFill size={20}/> NUEVO AUTOR
                    </button>
                  </div>
                }
                role={['admin', 'editor']}
                lang={lang}
              />
              {paginateAuthors()}
            </Row>
          </div >
          <Row className='justify-content-md-center'>
            <CustomPagination 
              step={step} 
              setStep={setStep} 
              pages={pages} 
              pagesToShow={13}
              fetchData={nextFetchAuthors} />
          </Row>
      </>
    )
  }

  const showGallery = () => {

    if(viewer){
      return (
        <AuthorDetails {...{...props, id}}/>
      );
    }

    // If the books are not present yet, display loading feedbaack to user.
    if (loading) {
      return (
        <Row className='justify-content-md-center'>
          <div style={{ paddingTop: '40px' }} />
          <TextLoader
            upperMessage={'Cargando'} //lang.author.loading.books_upper}
            lowerMessage={'Estamos obteniendo los autores'} //lang.author.loading.books_lower}
          />
        </Row>
      )
    }
    // TODO retornar un componente especial cuando no existan libros para mostrar.
    if (authors && authors.length === 0) {
      return (
        <Row className='justify-content-md-center'>
            <div style={{ paddingTop: '40px' }} />
            <TextLoader
              upperMessage={'No se han obtenido autores.'} //lang.author.loading.books_upper}
              lowerMessage={''} //lang.author.loading.books_lower}
            />
            <div style={{ paddingTop: '60%' }} />
            <CustomPagination 
              step={step} 
              setStep={setStep} 
              pages={pages} 
              pagesToShow={13}
              fetchData={nextFetchAuthors} />
        </Row>
      )
    }

    return displayAuthors();
  }

  return (
    <>
      <SearchBar 
        searchItem={ setQuery }
        query={query}
        setQuery={setQuery}
        placeholder="Apellido | Nombre" 
      />
      <Row className='justify-content-md-center'>
        {showGallery()}
      </Row>
    </>
  );
};

export default AuthorGallery;
